import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEDivider, FormEditButton, FHETextField, FHEReactSelect, FHEMiniFormEditButton } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import memoizeOne from 'memoize-one';
import { updateProductModule, updateThreshold, updateReversePolarity } from '../../../../../data/Products/actions';

class Relay extends PureComponent {
    static propTypes = {
        enumProductModulesTypes: PropTypes.array.isRequired,
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        planningMode: PropTypes.string,
        maxAutonomy: PropTypes.number,
        idleTime: PropTypes.number,
        power: PropTypes.number,
        moduleType: PropTypes.string,
        productType: PropTypes.string,
        threshold: PropTypes.number,
        code: PropTypes.string,
        lineType: PropTypes.string,
        planningSynched: PropTypes.number,
        value: PropTypes.string,
        idlePower: PropTypes.number,
        reversePolarity: PropTypes.number,
        loadTime: PropTypes.number,
        label: PropTypes.string,
        planningType: PropTypes.string,
        favorite: PropTypes.number,
        updateProductModule: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        expanded: PropTypes.string,
        productModulekey: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        type: PropTypes.string,
        updateThreshold: PropTypes.func.isRequired,
        updateReversePolarity: PropTypes.func.isRequired,
        fheCenter_mac: PropTypes.string
    };

    static defaultProps = {
        expanded: null,
        planningMode: null,
        maxAutonomy: null,
        idleTime: null,
        power: null,
        moduleType: null,
        productType: null,
        threshold: null,
        code: null,
        lineType: null,
        planningSynched: null,
        value: null,
        idlePower: null,
        reversePolarity: null,
        loadTime: null,
        label: null,
        planningType: null,
        favorite: null,
        type: null,
        fheCenter_mac: null
    };

    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            formThresholdDisabled: true,
            formReversePolarityDisabled: true,
            textInput_error: {},
            sendLoading: false,
            sendLoadingThreshold: false,
            sendLoadingReversePolarity: false,
            loadingThreshold: true,
            loadingReversePolarity: true,
            form: {
                moduleType: null,
                label: null,
                favorite: null
            }
        };

        this.favorites = [
            { value: 0, label: Translator.translate('general.productModules.0') },
            { value: 1, label: Translator.translate('general.productModules.1') }
        ];
        this.polarities = [
            { value: 0, label: Translator.translate(`general.productModules.0`) },
            { value: 1, label: Translator.translate('general.productModules.1') }
        ];
    }

    static getDerivedStateFromProps(props, state) {
        const { formDisabled, formThresholdDisabled, formReversePolarityDisabled } = state;
        const { moduleType, label, favorite, threshold, reversePolarity } = props;

        let stateObject = {};

        if (formDisabled) {
            let form = {
                moduleType: state.form.moduleType,
                label: state.form.label,
                favorite: state.form.favorite
            };
            if (props.moduleType !== state.form.moduleType) {
                form.moduleType = moduleType;
            }
            if (props.label !== state.form.label) {
                form.label = label;
            }
            if (props.favorite !== state.form.favorite) {
                form.favorite = favorite;
            }
            stateObject = {
                ...stateObject,
                form: form
            };
        }
        if (formThresholdDisabled) {
            stateObject = {
                ...stateObject,
                threshold: threshold,
                loadingThreshold: false
            };
        }
        if (formReversePolarityDisabled) {
            stateObject = {
                ...stateObject,
                reversePolarity: reversePolarity,
                loadingReversePolarity: false
            };
        }
        return stateObject;
    }

    handleEdit = () => {
        const { formDisabled } = this.state;
        if (formDisabled === true) {
            this.setState({
                formDisabled: false,
                formReversePolarityDisabled: true,
                formThresholdDisabled: true
            });
        } else {
            this.loadInputs();
        }
    };

    handleEditThreshold = () => {
        const { formThresholdDisabled } = this.state;
        if (formThresholdDisabled === true) {
            this.setState({
                formDisabled: true,
                formReversePolarityDisabled: true,
                formThresholdDisabled: false
            });
        } else {
            this.loadInputs();
        }
    };

    handleEditReversePolarity = () => {
        const { formReversePolarityDisabled } = this.state;
        if (formReversePolarityDisabled === true) {
            this.setState({
                formDisabled: true,
                formThresholdDisabled: true,
                formReversePolarityDisabled: false
            });
        } else {
            this.loadInputs();
        }
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    handleChangeWithVerification = event => {
        const { form, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = form[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            form: { ...form, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    handleChange = event => {
        const { form } = this.state;

        if (event.target.name === 'threshold' || event.target.name === 'reversePolarity') {
            let value;
            if (event.target.name === 'reversePolarity') {
                value = parseInt(event.target.value);
            } else {
                value = event.target.value;
            }
            this.setState({
                [event.target.name]: value
            });
        } else {
            let value;
            if (event.target.name === 'favorite') {
                value = parseInt(event.target.value);
            } else {
                value = event.target.value;
            }
            this.setState({
                form: { ...form, [event.target.name]: value }
            });
        }
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { moduleType, label, favorite, threshold, reversePolarity } = this.props;
        this.setState({
            formDisabled: true,
            formThresholdDisabled: true,
            formReversePolarityDisabled: true,
            textInput_error: {},
            sendLoading: false,
            sendLoadingThreshold: false,
            sendLoadingReversePolarity: false,
            loadingThreshold: true,
            loadingReversePolarity: true,
            form: {
                moduleType: moduleType,
                label: label,
                favorite: parseInt(favorite)
            },
            threshold: threshold,
            reversePolarity: reversePolarity
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    formatForm = () => {
        const { form } = this.state;
        let newForm = form;
        Object.keys(newForm).forEach(key => {
            if (newForm[key] === '') {
                newForm[key] = null;
            }
        });
        this.setState({
            form: newForm
        });
    };

    confirmEdit = () => {
        const { form } = this.state;
        const { updateProductModule, match, code, type, lineType, history } = this.props;

        this.formatForm();

        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });

            return updateProductModule(match.params.homeId, match.params.productIdentifier, match.params.productType, code, form, type, lineType)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.products.actions.editProductModuleSuccess`));
                    this.loadInputs();
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(Translator.translate(`generic.products.actions.editProductModuleError`));
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                    }
                });
        }
    };

    confirmEditThreshold = () => {
        const { threshold } = this.state;
        const { updateThreshold, match, code, type, fheCenter_mac, history } = this.props;

        if (this.validateThreshold(threshold)) {
            this.setState({
                sendLoadingThreshold: true,
                formThresholdDisabled: true
            });
            return updateThreshold(fheCenter_mac, match.params.productIdentifier, type, code, parseInt(threshold))
                .then(() => {
                    Toastr.success(Translator.translate(`generic.products.actions.editProductModuleThresholdSuccess`));
                    this.loadInputs();
                })
                .catch(error => {
                    this.setState({
                        sendLoadingThreshold: false,
                        formThresholdDisabled: false
                    });
                    Toastr.error(
                        Translator.translateWithFallback(`socket.error.${error.message ? error.message : error}`, 'socket.error.defaultError'),
                        Translator.translate(`generic.products.actions.editProductModuleError`)
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                    }
                });
        }
    };

    confirmEditReversePolarity = () => {
        const { reversePolarity } = this.state;
        const { updateReversePolarity, match, code, type, fheCenter_mac, history } = this.props;

        this.setState({
            sendLoadingReversePolarity: true,
            formReversePolarityDisabled: true
        });

        return updateReversePolarity(fheCenter_mac, match.params.productIdentifier, type, code, reversePolarity)
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.actions.editProductModuleReversePolaritySuccess`));
                this.loadInputs();
            })
            .catch(error => {
                this.setState({
                    sendLoadingReversePolarity: false,
                    formReversePolarityDisabled: false
                });
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${error.message ? error.message : error}`, 'socket.error.defaultError'),
                    Translator.translate(`generic.products.actions.editProductModuleError`)
                );
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                }
            });
    };

    validateForm = () => {
        const errors = {};

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    validateThreshold = threshold => {
        const errors = {};

        if (isNaN(parseInt(threshold))) {
            errors['threshold'] = Translator.translate('general.fields.error.any.notANumber');
        }
        if (typeof parseInt(threshold) !== 'number') {
            errors['threshold'] = Translator.translate('general.fields.error.any.notANumber');
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    getSelectedPolarity = memoizeOne(polarity => {
        return this.polarities.find(x => x.value === polarity);
    });

    getSelectedFavorite = memoizeOne(favorite => {
        return this.favorites.find(x => x.value === favorite);
    });

    getSelectedType = memoizeOne(type => {
        const { enumProductModulesTypes } = this.props;
        return enumProductModulesTypes.find(x => x.value === type);
    });

    handleReactSelect = (event, options) => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [options.name]: event.value }
        });
    };
    render() {
        const {
            enumProductModulesTypes,
            planningMode,
            maxAutonomy,
            idleTime,
            power,
            productType,
            code,
            lineType,
            planningSynched,
            value,
            idlePower,
            loadTime,
            planningType,
            theme,
            expanded,
            productModulekey,
            profile,
            history,
            type
        } = this.props;
        const {
            formDisabled,
            formThresholdDisabled,
            formReversePolarityDisabled,
            textInput_error,
            sendLoading,
            sendLoadingThreshold,
            sendLoadingReversePolarity,
            form,
            loadingThreshold,
            loadingReversePolarity,
            threshold,
            reversePolarity
        } = this.state;
        const userRightUpdate =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`productModules_${type}_${lineType}_update`);
        return (
            <Fragment>
                {expanded === productModulekey && userRightUpdate && (
                    <FormEditButton
                        useSecondaryPosition
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                )}

                <FHEContainerForm withoutPadding>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="label"
                                value={!form.label || form.label === null ? '' : form.label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChangeWithVerification}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="moduleType"
                                label={Translator.translate('general.table.column.moduleType')}
                                disabled={formDisabled}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedType(form.moduleType)}
                                choices={enumProductModulesTypes}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="favorite"
                                label={Translator.translate('general.table.column.favorite')}
                                disabled={formDisabled}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedFavorite(form.favorite)}
                                choices={this.favorites}
                            />
                        </Grid>
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.productType')}
                                itemContent={Translator.translate(`general.productModules.${productType}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.lineType')}
                                itemContent={Translator.translate(`general.productModules.${lineType}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                        </Grid>
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningMode')}
                                itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningSynched')}
                                itemContent={Translator.translate(`general.productModules.${planningSynched}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningType')}
                                itemContent={Translator.translate(`general.productModules.${planningType}`)}
                            />
                        </Grid>
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.maxAutonomy')} itemContent={maxAutonomy} />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.idleTime')} itemContent={idleTime} />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.power')} itemContent={power} />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.value')} itemContent={value} />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.idlePower')} itemContent={idlePower} />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.loadTime')} itemContent={loadTime} />
                        </Grid>
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEMiniFormEditButton
                                handleEdit={this.handleEditReversePolarity}
                                confirmEdit={this.confirmEditReversePolarity}
                                sendLoading={sendLoadingReversePolarity}
                                loading={loadingReversePolarity}
                                formDisabled={formReversePolarityDisabled}
                                hasRightToEdit={userRightUpdate}
                            >
                                <FHEReactSelect
                                    name="reversePolarity"
                                    label={Translator.translate('general.table.column.reversePolarity')}
                                    disabled={formReversePolarityDisabled}
                                    onChange={this.handleReactSelect}
                                    value={this.getSelectedPolarity(reversePolarity)}
                                    choices={this.polarities}
                                />
                            </FHEMiniFormEditButton>
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEMiniFormEditButton
                                handleEdit={this.handleEditThreshold}
                                confirmEdit={this.confirmEditThreshold}
                                sendLoading={sendLoadingThreshold}
                                loading={loadingThreshold}
                                formDisabled={formThresholdDisabled}
                                hasRightToEdit={userRightUpdate}
                            >
                                <FHETextField
                                    disabled={formThresholdDisabled}
                                    id="label"
                                    value={threshold === null ? '' : threshold}
                                    error={textInput_error.threshold}
                                    label={Translator.translate('general.table.column.threshold')}
                                    name="threshold"
                                    onChange={this.handleChange}
                                    type="number"
                                />
                            </FHEMiniFormEditButton>
                        </Grid>
                    </Grid>
                </FHEContainerForm>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const productModulekey = props.productModulekey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());

    const productModule = state.environments[history.environment].data.Products.getIn(
        ['list', productKey, 'productModules', productModulekey],
        new Map()
    );
    let fheCenter_mac = null;
    state.environments[history.environment].data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === productModule.get('homeId')) fheCenter_mac = macAddress;
    });
    const enums = state.environments[history.environment].enums;
    return {
        enumProductModulesTypes: enums.productModulesTypes || [],
        profile: state.data.user,
        type: product.get('type'),
        planningMode: productModule.get('planningMode'),
        maxAutonomy: productModule.get('maxAutonomy'),
        idleTime: productModule.get('idleTime'),
        power: productModule.get('power'),
        imageName: productModule.get('imageName'),
        moduleType: productModule.get('moduleType'),
        productType: productModule.get('productType'),
        threshold: productModule.get('threshold'),
        code: productModule.get('code'),
        lineType: productModule.get('lineType'),
        planningSynched: productModule.get('planningSynched'),
        value: productModule.get('value'),
        idlePower: productModule.get('idlePower'),
        reversePolarity: productModule.get('reversePolarity'),
        loadTime: productModule.get('loadTime'),
        label: productModule.get('label'),
        planningType: productModule.get('planningType'),
        productIdentifier: productModule.get('productIdentifier'),
        favorite: productModule.get('favorite'),
        productModulekey,
        fheCenter_mac
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/ProductModule/Relay/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductModule,
                        updateThreshold,
                        updateReversePolarity
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(Relay))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/ProductModule/Relay/index.js